<template>
  <div class="lookForMonth_wrapper">
    <div class="lookForMonth_top">
      <div class="selectDate">
        <!--<div>{{year}} 年 {{month}} 月</div>-->
        <div class="calendarMonth">
          <el-date-picker
            class="month"
            v-model="calendarMonth"
            type="month"
            format="yyyy-MM"
            value-format="yyyy-MM"
            editable
            :clearable="false"
            @change="calendarMonthChange">
          </el-date-picker>
        </div>
        <div class="upDownSelect">
          <div class="upDownSelect_item" @click="dateUp"></div>
          <div class="upDownSelect_item" @click="dateDown"></div>
        </div>
      </div>
    </div>
    <!--:style="calendarStyle"-->
    <div class="calendar">
      <div v-for="(item,index) in calendarData" class="calendar_item" :key='index' :class="{ash:item.color==='ash',date:index>6&&item.color!=='ash'}">
        <div class="dateBox" :class="{ dateMsg:calendarList[index],showMore:showMsg == index}" v-if="index>6">
          <p>{{item.label}}</p>
          <!--//收起-->
          <div class="msg" v-if="showMsg != index">
            <el-tooltip class="item"  v-if="item.color!=='ash'&&index>=7&&calendarList[index]" effect="dark" :content="calendarList[index][0]" placement="top-start">
              <div class="ellipsis">
                {{calendarList[index][0]}}
              </div>
            </el-tooltip>
          </div>
         <!--展开-->
          <div class="msg" v-if="showMsg == index&&item.color!=='ash'&&calendarList[index]">
              <el-tooltip class="item"   v-for="(msg, index) in calendarList[index]" effect="dark" :content="msg" placement="top-start" :key="index">
                <div class="ellipsis">
                  {{msg}}
                </div>
              </el-tooltip>
          </div>
          <!--显示更多-->
          <span class="moreMsg" v-if="item.color!=='ash'&&calendarList[index]&&calendarList[index].length > 1" @click="showMore(index)">
              <svg class="icon" aria-hidden="true" v-if="showMsg != index">
                <use xlink:href="#icon-youjiantou"></use>
              </svg>
             <svg class="icon" aria-hidden="true" v-else>
                <use xlink:href="#icon-xiajiantou"></use>
              </svg>
            </span>
        </div>
        <div class="week" v-else>{{item.label}}</div>
      </div>
    </div>
  </div>
</template>
<script>
  import { formatNum } from "../../util/util";
  import { zqClendarInfo_ajaxGetCustomZqCalendar } from '@/api/home/platformWCS';
  import { mapGetters } from 'vuex';
  export default {
    name: "lookForMonth",
    data() {
      return {
        calendarData: [{label:"日"},{label: "一"}, {label:"二"},{label: "三"},{label: "四"},{label: "五"},{label: "六"}], //日历循环渲染数据
        year: 0, //当前日期年
        month: 0, //当前日期月数
        date: 0, //当前日期号数
        day: -1, //当前星期几
        num:0,//1号星期几
        showMsg:null,
        calendarMonth:"",//日历月份
        calendarMsg:{
          // "2021-03-01":["我是第一条数据","我是第二条数据","我是第三条数据"],
          // "2021-03-03":["我是第一条数据","我是第二条数据","我是第三条数据"],
          // "2021-03-09":["我是第一条数据","我是第二条数据","我是第三条数据"],
          // "2021-03-12":["我是第一条数据","我是第二条数据"],
          // "2021-03-18":["我是第一条数据"],
          // "2021-03-27":["我是第一条数据"],
        },//日历消息数据
        calendarList:{},//处理后的日历数据
      };
    },
    filters:{
    },
    computed: {
      ...mapGetters([
        'userInfo'
      ])
    },
    async created(){
      // 获取当前日期数据
      this.getNow();
      // 获取当前月份一号的时间戳
      this.getCalendarDate(); // 给calendarData添加当月数据
      // this.getCalendarData();
    },
    mounted() {
      this.setMsg();
    },
    methods: {
      // 获取当前时间
      getNow(date) {
        date = date || this.userInfo.month;
        this.calendarMonth = date;
        const yearMonth = new Date(date);
        this.year = yearMonth.getFullYear();
        this.month = yearMonth.getMonth() + 1;
        this.date = yearMonth.getDate();
        this.day = yearMonth.getDay();
      },
      // 获取每个月的天数
      monthDay(month) {
        if ([1,3,5,7,8,10,12].includes(month)) {
          return 31
        } else if ([4,6,9,11].includes(month)) {
          return 30
        } else if (month === 2) {
          // 判断当年是否为闰年
          if (
            (this.year % 4 === 0 && this.year % 100 !== 0) ||
            this.year % 400 === 0
          ) {
            return 29
          } else {
            return 28
          }
        }
      },
      // 给calendarData添加当月数据
      getCalendarDate() {
        // 获取当前月份一号星期几
        let firstDay = new Date(this.year + "-" + this.month + "-" + "01").getDay();
        this.calendarData = [{label:"日"},{label: "一"}, {label:"二"},{label: "三"},{label: "四"},{label: "五"},{label: "六"}];
        let num = parseInt(firstDay);
        this.num = num;
        let nowDays = this.monthDay(this.month);
        let lastMonth = this.month - 1>0?this.month - 1:12;
        let lastDays = this.monthDay(lastMonth);
        // 循环添加上一个月数据
        for (let i = 0; i < num; i++) {
          this.calendarData.push({label:lastDays - num + i + 1,color:'ash'});
        }
        // 循环添加当月数据
        for (let i = 0; i < nowDays; i++) {
          this.calendarData.push({label:i + 1});
        }
        // 循环添加下一个月数据(如果不够6行，再补一行)
        let surplusDay;
        if(this.calendarData.length < 49){
          surplusDay = 49 - this.calendarData.length;
        }
        if (this.calendarData.length % 7 !== 0 || surplusDay == 14 || surplusDay == 7 ) {
          for (let i = 0; i < surplusDay; i++) {
            this.calendarData.push({label:i + 1,color:'ash'});
          }
        }
        this.loading = false
      },
      // 将日期调上
      dateUp() {
        let month = this.month;
        let year = this.year;
        month--;
        if (month <= 0) {
          year--;
          month = 12;
        }
        this.getNow(year + '-' + month);
        this.getCalendarDate();
      },
      // 将日期调下
      dateDown() {
        let month = this.month;
        let year = this.year;
        month++;
        if (month > 12) {
          year++;
          month = 1;
        }
        this.getNow(year + '-' + month);
        this.getCalendarDate();
      },
      // 日期框值改变
      calendarMonthChange(val) {
        this.getNow(val);
        this.getCalendarDate();
      },
      showMore(index){
        if(this.showMsg == index){
          this.showMsg = null;
        }else{
          this.showMsg = index;
        }
      },
      setMsg(){
        // 获取index
        this.calendarList = {};
        for(let key in this.calendarMsg){
          // 加上星期的index和1号之前的index
          let index = parseInt(key.split("-")[2]) + 7 + this.num;
          this.$set(this.calendarList,index,this.calendarMsg[key]);
        }
      },
      getCalendarData() {
        let params = {
          zqScopeName: 'month',
          zqStartDate: '2014-09-28',
          zqEndDate: '2014-11-09'
        }
        let formData = new FormData();
        formData.append('zqScopeName', params.zqScopeName);
        formData.append('zqStartDate', params.zqStartDate);
        formData.append('zqEndDate', params.zqEndDate);
        zqClendarInfo_ajaxGetCustomZqCalendar(formData)
          .then(response => {
            console.log(response,"dddddddddddddddddddddddddd")
          })
          .catch(error => {

          })
      }
    }
  };
</script>
<style lang="scss" scoped>
  .lookForMonth_wrapper {
    /*padding: 20px 0;*/
    margin: auto;
  }
  .lookForMonth_top {
    margin-bottom: 25px;
    overflow: hidden;
    .selectTeacher {
      float: left;
    }
    .selectDate {
      float: right;
      display: flex;
      .upDownSelect {
        display: flex;
        flex-direction: column;
        margin-top: -2px;
        margin-left: 5px;
        .upDownSelect_item {
          width: 0;
          height: 0;
          border: 7px solid transparent;
          cursor: pointer;
        }
        .upDownSelect_item:nth-child(1) {
          border-bottom: 7px solid #ccc;
          margin-bottom: 5px;
          &:hover {
            border-bottom: 7px solid skyblue;
          }
        }
        .upDownSelect_item:nth-child(2) {
          border-top: 7px solid #ccc;
          &:hover {
            border-top: 7px solid skyblue;
          }
        }
      }
    }
  }
  .calendarMonth{
    width: 120px;
    display: flex;
    justify-content: flex-end;
  }
  /* 日历表样式=======================================↓ */
  .calendar {
    /*border-top: 1px solid #ccc;*/
    /*border-left: 1px solid #ccc;*/
    display: flex;
    flex-wrap: wrap;
    box-sizing: border-box;
    .calendar_item {
      height: 44px;
      box-sizing: border-box;
      flex-basis:14.28%;
      padding-left: 5px;
      /*border-right: 1px solid #ccc;*/
      /*border-bottom: 1px solid #ccc;*/
      /*text-align: center;*/
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      /*align-items: center;*/
      &.date:hover{
        /*background: #eee;*/
      }
      .status{
        margin-top: 10px;
        &.textBlue{
          color: blue;
        }
        &.textRed{
          color: brown;
        }
      }
      .el-icon-edit-outline{
        cursor: pointer;
        margin-left: 7px;
      }
    }

    .dateBox{
      margin-bottom: 4px;
      position: relative;
      padding:2px 3px;
      height: 20px;
      transition: all 0.5s;
      p{
        font-size: 12px;
        width: 20px;
        height: 20px;
        color: #333;
        border-radius: 50%;
        text-align: center;
        line-height: 20px;
        font-weight: bold;
      }
    }
    .ash{
      color: gainsboro;
      p{
        color: #999999;
        font-weight: normal;
      }
    }
    .week{
      /*text-align: center;*/
      padding-left: 5px;
      font-weight: bold;
    }
    .dateMsg{
      background: #EC5858;
      border-radius: 12px;
      padding-right: 20px;
      p{
        color:#ffffff;
        font-size: 12px;
          width: 20px;
          height: 20px;
          background: #ffffff;
          color: red;
          border-radius: 50%;
          text-align: center;
          line-height: 20px;
      }
      .msg{
        width: calc(100% - 44px);
        position: absolute;
        top: 3px;
        left: 26px;
        color:#ffffff;
        font-size: 12px;
        line-height: 18px;
      }
      .moreMsg{
        cursor: pointer;
        position: absolute;
        top:0px;
        right:0;
        display: inline-block;
        width: 20px;
        font-size: 12px;
        color: #ffffff;
        text-align: center;
      }
    }
    .showMore{
      height: 40px;
    }
    .showMore .msg{
      height: 36px;
      overflow-y: auto;
    }
  }
</style>
